<template>
    <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
    >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="value"
            :label="label"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            :outlined="outlined"
            :dense="dense"
            :hide-details="hideDetails"
            :disabled="disabled"
          ></v-text-field>
        </template>
        <v-date-picker
            :value="value"
            no-title
            scrollable
            :min="minDate"
            :max="maxDate"
            @input="updateDate"
        >
        </v-date-picker>
    </v-menu>
</template>
<script>
export default {
  name: 'dateComponent',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: String,
      default: null
    },
    minDate: {
      type: String,
      default: null
    },
    maxDate: {
      type: String,
      default: null
    },
    outlined: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    dense: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      menu: false,
      selectedDate: null,
      max: this.maxDate,
      min: this.minDate
    }
  },
  methods: {
    updateDate: function (date) {
      this.$emit('input', date)
      this.menu = false
    }
  }
}
</script>
